export enum PasswordField {
  Password = 'password',
}

export type PasswordFormValues = {
  [PasswordField.Password]: string;
};
